
import {
    defineComponent,
    toRefs
} from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import BreadCrumb from "@/components/cigo-admin-core/topBar/BreadCrumb.vue";
import ToolsBar from "@/components/cigo-admin-core/topBar/ToolsBar.vue";
import ManagerIcon from "@/components/cigo-admin-core/topBar/ManagerIcon.vue";
import OpenPages from "@/components/cigo-admin-core/topBar/OpenPages.vue";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";;

export default defineComponent({
    name: "CigoTopBar",
    components: {
        CigoIconFont,
        BreadCrumb,
        ToolsBar,
        ManagerIcon,
        OpenPages
    },
    setup(props) {
        return {
            CigoAdminStore,
            ...toRefs(CigoAdminStore.getState().systemState)
        };
    }
});
